import { Capacitor } from '@capacitor/core';

export const REMOTE_URL = 'https://www.stellarskyimager.fr';

/**
 * Retourne l'URL absolue ou relative selon la plateforme (Native vs Web)
 * @param path Le chemin de l'API (ex: '/api/export-session-pdf')
 */
export const getApiUrl = (path: string): string => {
    // Si le chemin est déjà absolu, on ne fait rien
    if (path.startsWith('http')) return path;

    // S'assurer que le chemin commence par /
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    if (Capacitor.isNativePlatform()) {
        return `${REMOTE_URL}${normalizedPath}`;
    }

    return normalizedPath;
};

